import i18next from 'i18next';
import { ErrorLogEntry } from '../../services/admin';

interface ErrorLogsCardProps {
  errors: ErrorLogEntry[];
}

export function ErrorLogsCard({ errors }: ErrorLogsCardProps) {
  const formatTime = (timestamp: string): string => {
    const date = new Date(timestamp);
    const locale = i18next.language === 'pl' ? 'pl-PL' : 'en-US';
    return date.toLocaleString(locale, {
      hour: '2-digit',
      minute: '2-digit',
      day: '2-digit',
      month: '2-digit',
    });
  };

  const getProcessLabel = (processType: string): string => {
    const labels: Record<string, string> = {
      saos_fetch: 'SAOS',
      cbosa_fetch: 'CBOSA',
      ingestion: 'Import',
      cbosa_ingestion: 'CBOSA Import',
      embeddings: 'Embeddings',
      chunk_embeddings: 'Chunks',
      reprocessing: 'Reprocess',
      cleanup: 'Cleanup',
    };
    return labels[processType] || processType;
  };

  if (errors.length === 0) {
    return (
      <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6">
        <h2 className="text-lg font-semibold text-slate-900 dark:text-white mb-4">Ostatnie bledy</h2>
        <div className="text-center py-6">
          <svg className="w-12 h-12 mx-auto text-green-500 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="text-sm text-slate-500 dark:text-slate-400">Brak ostatnich bledow</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-slate-900 dark:text-white">Ostatnie bledy</h2>
        <span className="text-sm text-red-600 dark:text-red-400 font-medium">
          {errors.length} bledow
        </span>
      </div>

      <div className="space-y-3 max-h-64 overflow-y-auto">
        {errors.map((error, index) => (
          <div
            key={index}
            className="p-3 bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-900/40 rounded-lg"
          >
            <div className="flex items-start justify-between gap-2 mb-1">
              <span className="text-xs font-medium text-red-700 dark:text-red-300 px-1.5 py-0.5 bg-red-100 dark:bg-red-900/40 rounded">
                {getProcessLabel(error.processType)}
              </span>
              <span className="text-xs text-red-500 dark:text-red-400 whitespace-nowrap">
                {formatTime(error.timestamp)}
              </span>
            </div>
            <p className="text-sm text-red-800 dark:text-red-200 break-words">
              {error.message}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
